import { LineList } from 'Components'
import { ICreateJobForm } from '@/Models'
import { useFormContext } from 'react-hook-form'

interface PreviewProps {
  goToStep: (step: number) => void
}

export const CreateJobPreviewComp = ({ goToStep }: PreviewProps) => {
  const { getValues } = useFormContext<ICreateJobForm>()
  const data = getValues()

  return (
    <div className='shadow-sm- rounded'>
      <h5 className='mb-4 fw-bold text-default d-none'>Review Your Responses</h5>
      <div className='row'>
        <div className='col'>
          {/* employment info */}
          <section className='mb-4 border-end pe-3'>
            <ul className='list-group list-group-flush mt-1'>
              <li className='list-group-item d-flex justify-content-between border-0'>
                <span>Job Title</span> <span>{data.jobTitle}</span>
              </li>
              <li className='list-group-item d-flex justify-content-between border-0'>
                <span>Department</span> <span>{data.department}</span>
              </li>
              <li className='list-group-item d-flex justify-content-between border-0'>
                <span>Employment Type</span> <span>{data.employmentType}</span>
              </li>
              <li className='list-group-item d-flex justify-content-between border-0'>
                <span>Location</span> <span>{data.location}</span>
              </li>
              <li className='list-group-item d-flex justify-content-between border-0'>
                <span>Work arrangement</span> <span>{data.workArrangement}</span>
              </li>
              <li className='list-group-item d-flex justify-content-between border-0'>
                <span>Salary</span> <span>Not specified</span>
              </li>
              <li className='list-group-item d-flex justify-content-between border-bottom'>
                <span>Deadline</span> <span>{data.applicationDeadline}</span>
              </li>
            </ul>
            <div className='text-start custom-app'>
              <strong className=''>Application Questions</strong>
              <p className='mt-1'>{data.customQuestions.length} custom questions configured.</p>
            </div>
          </section>

          {/* final notes */}
          <section className='mb-2 d-none'>
            <div className='d-flex justify-content-between align-items-center border-bottom pb-2'>
              <button className='btn btn-sm btn-outline-default d-none' onClick={() => goToStep(3)}>
                Edit
              </button>
            </div>
            <ul className='list-group list-group-flush mt-3'>
              <li className='list-group-item d-flex justify-content-between'>
                {/* <span>Suggestion for Benefits:</span> <span>{data.customQuestions.title}</span> */}
              </li>
              <li className='list-group-item d-flex justify-content-between'>
                {/* <span>Problems Encountered:</span> <span>{data.customQuestions.type}</span> */}
              </li>
            </ul>
          </section>
        </div>
        <div className='col'>
          <section className='second-con mt-3 mb-2'>
            <div className='about-role'>
              <h4>About the Role</h4>
              <p>{data.aboutRole}</p>
            </div>
            <div className='about-role mt-2'>
              <h4>Responsibilities</h4>
              <ul className='list-group list-group-flush mt-2 ps-4'>
                <LineList
                  value={data.responsibility}
                  className='d-fle justify-content-between list-req'
                />
              </ul>
            </div>
            <div className='about-role mt-2'>
              <h4>Requirements</h4>
              <ul className='list-group list-group-flush mt-2 ps-4'>
                <LineList
                  value={data.requirement}
                  className='d-fle justify-content-between list-req'
                />
              </ul>
            </div>
            <div className='about-role mt-2'>
              <h4>Skills</h4>
              <p>{data.skills}</p>
            </div>
            <div className='about-role mt-2'>
              <h4>About Tradegrid</h4>
              <p>{data.aboutTradegrid}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}
